// src/constants/subjectMeta.js
import bio from '../assets/biology.avif';
import math from '../assets/math.webp';
import chem from '../assets/chemistry.avif';
import com from '../assets/commerce.jpeg';
import eng from '../assets/english.png';
import geo from '../assets/geography.jpeg';
import hist from '../assets/history.jpeg';
import lit from '../assets/literature.jpeg';
import rel from '../assets/religion.jpeg';

export const deslugify = (slug = '') =>
  slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const formatExamLabel = (examSlug = '') =>
  String(examSlug).toUpperCase();

export const SUBJECT_META = {
  bgcse: {
    biology: {
      label: 'Biology',
      examLabel: 'BGCSE',
      image: bio,
      subjectId: 1,
    },
    mathematics: {
      label: 'Mathematics',
      examLabel: 'BGCSE',
      image: math,
    },
    chemistry: {
      label: 'Chemistry',
      examLabel: 'BGCSE',
      image: chem,
    },
    commerce: {
      label: 'Commerce',
      examLabel: 'BGCSE',
      image: com,
    },
    'english-language': {
      label: 'English Language',
      examLabel: 'BGCSE',
      image: eng,
    },
    geography: {
      label: 'Geography',
      examLabel: 'BGCSE',
      image: geo,
    },
    history: {
      label: 'History',
      examLabel: 'BGCSE',
      image: hist,
    },
    literature: {
      label: 'Literature',
      examLabel: 'BGCSE',
      image: lit,
    },
    religion: {
      label: 'Religion',
      examLabel: 'BGCSE',
      image: rel,
    },
  },
};

export const getSubjectMeta = (examSlug, subjectSlug) =>
  SUBJECT_META?.[examSlug]?.[subjectSlug] || null;